export const symbolOfAttributeHasBeenSet = Symbol.for("attributeHasBeenSet");
export const symbolOfMarkAttributeHasBeenSet = Symbol.for("markAttributeHasBeenSet");
export const symbolOfStopAttributeChangedCallback = Symbol.for("stopAttributeChangedCallback");
//# sourceMappingURL=symbols.js.map